import React from 'react';

import ManagedFormGroup from 'components/form/managed_input/form_group';

import type { AddContactWorkflow } from './workflow';

interface Props {
  workflow: AddContactWorkflow;
}

export function ContactRoleInput({ workflow }: Props) {
  const { roleOptions, role } = workflow;

  // A single option is auto-selected by the workflow hook, so don't render a single option
  if (!roleOptions || roleOptions.length < 2) {
    return null;
  }

  return (
    <ManagedFormGroup
      label="Role"
      name="role"
      options={roleOptions}
      placeholder="Choose from the dropdown"
      required
      type="combobox"
      value={role}
      onValueChange={role => workflow.change({ role })}
    />
  );
}
